<template>
  <div class="container">
    <head-nav-bar title="自助开单" :fixed="true" />
    <div class="mt-header-nav" style="paddingTop:1px">
      <div v-if="$route.query.ourHospital">
        <van-notice-bar
          left-icon="volume-o"
          wrapable
          :scrollable="false"
          text="此功能为本院医务人员核酸快速检测通道，非本院人员无法使用，请从“核酸检测”进去开单检测"
        />
      </div>
      <DataList api="Contact_List" :onLoadCallBack="onLoad">
        <template v-slot:item="item" style="padding:10px">
          <div class="contactItem">
            <div class="CardholderName">
              {{ item.obj.cardholderName }}
            </div>
            <div class="CardNo">就诊卡号：{{ item.obj.cardNo }}</div>
            <van-button
              @click="chooseBtn(item.obj)"
              type="info"
              size="small"
              class="chooseBtn"
              >选择此卡</van-button
            >
          </div>
        </template>
      </DataList>
      <div @click="toAddCard" v-if="!concactLength" class="register">
        没有健康卡，注册申领
      </div>
    </div>
    <van-dialog v-model="showTips">
      <div
        @click="showTips = false"
        class="ModalHtml"
        v-html="outpatientTechApplyRemark"
      ></div>
    </van-dialog>
  </div>
</template>

<script>
import DataList from "@/components/DataList";
import { Button, Dialog, Notify, NoticeBar, Toast } from "vant";

export default {
  components: {
    DataList,
    [Button.name]: Button,
    [Dialog.Component.name]: Dialog.Component,
    [NoticeBar.name]: NoticeBar
  },
  data() {
    return {
      info: {},
      showTips: false,
      outpatientTechApplyRemark: "",
      concactLength: 0
    };
  },
  created() {
    this.$post("GetWxSystemParameterInfo", {}).then(res => {
      this.outpatientTechApplyRemark = res.data.outpatientTechApplyRemark;
      if (this.outpatientTechApplyRemark) {
        this.showTips = true;
      }
    });
  },
  methods: {
    chooseBtn(item) {
      this.$router.push({
        name: "selfBuyBill",
        query: {
          ...item
        }
      });
    },
    postOurHospitalNewOutpatientInfo(
      item,
      reapply,
      api = "OurHospitalNewOutpatientInfo"
    ) {
      const that = this;
      Toast.loading({
        message: "处理中...",
        duration: 0,
        forbidClick: true
      });
      this.$post(api, {
        patientName: item.cardholderName,
        sex: item.cardholderSex + "",
        birthday: item.cardholderBirthDate,
        age: item.age,
        diagnosisCardNo: item.diagnosisCardNo,
        address: item.cardholderContactAddress,
        identityNo: item.identityDocNo,
        contactPhone: item.cardholderContactPhone,
        alarmRemark: "",
        reapply: reapply
      })
        .then(res => {
          console.log(res);
          Toast.clear();
          Notify({ background: "rgb(7,193,96)", message: "开单成功" });
        })
        .catch(err => {
          Toast.clear();
          if (err.data.message == "EXIST") {
            that.$router.push({
              name: "userBill",
              query: { ...that.params }
            });
          } else if (err.data.message == "EXISTCHARGED") {
            Dialog.confirm({
              message: `【${item.cardholderName}】：【${
                item.diagnosisCardNo
              }】今日存在已支付的自助申请检查，是否再次申请`
            })
              .then(() => {
                that.postOurHospitalNewOutpatientInfo(item, true, api);
              })
              .catch(() => {});
          }
        });
    },

    onLoad(res) {
      this.concactLength = res.data.datas.length;
    },
    toAddCard() {
      this.$router.push({
        name: "userContactAddCard",
        query: {
          fromPathName: "nucleinCheck"
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.contactItem {
  margin: 10px;
  border: 1px solid rgb(223, 224, 226);
  background-color: rgb(248, 248, 248);
  padding: 10px;
  position: relative;
  .CardholderName {
    font-weight: bold;
    font-size: 14px;
  }
  .CardNo {
    margin-top: 5px;
    font-weight: bold;
    font-size: 12px;
  }
  .chooseBtn {
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}
.ModalHtml {
  padding: 20px 20px 0;
}
.ModalHtml /deep/img {
  max-width: 100%;
}
.register {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  font-size: 16px;
  border: 1px solid rgb(183, 193, 194);
  color: rgb(70, 158, 209);
  width: 70%;
  padding: 10px 0;
  text-align: center;
  border-radius: 3px;
}
</style>
